import { IframeEventName, PostMessageType } from '@spazious/search-sdk-types';

function postInteractionEvent(name: IframeEventName.SEARCH_SUBMIT, extra: { url: string }): void;
function postInteractionEvent(name: IframeEventName.PICKER_OPEN): void;
function postInteractionEvent(name: IframeEventName.DESTINATION_FOCUS): void;
function postInteractionEvent(name: IframeEventName.RESET_REQUEST): void;

function postInteractionEvent(name: IframeEventName, extra?: Record<string, any>): void {
  window.parent.postMessage(
    {
      type: PostMessageType.IFRAME_EVENT,
      payload: {
        name,
        ...extra,
      },
    },
    '*'
  );
}

export default postInteractionEvent;
